import {CircularProgress, Grid, Typography} from '@mui/material'
import {useDispatch, useSelector} from 'react-redux'
import {selectedTab} from '../../../../../store/prospectSegment/selectedProspectsTab/selectedProspectsTabSlice'
import SegmentProspects from '../../../../../configs/prospectsSegmentTabList.json'
import {setCampaignView} from '../../../../../store/selectedView/campaignView/campaignViewIndex'
import SearchPanel from '../../../../Common/SearchPanel/SearchPanelIndex'
import {useEffect, useState} from 'react'
import prospectsActions from '../../../../../configs/prospectsAction.json'
import {StyledBox, StyledSaveAndGenerateButton} from '../../Styles'
import SaveList from '../../SaveList/SaveListIndex'
import {constituentIdList} from '../../../../../store/prospectSegment/savedProspectsList/saveProspectsListSlice'
import {useAddToSavedProspectList} from '../../../../../api/addToSavedList'
import {
  getAllProspectsData,
  getAllSavedProspectsData
} from '../../../../../store/prospectSegment/allProspectsData/allProspectsDataSlice'
import {getProspectsPageNumber, getSavedProspectsPageNumber} from '../../../../../store/pagination/pageNumberSlice'
import SavedProspects from '../../SavedProspects'
import {updatedAllProspectsSearchTerm, updatedSavedProspectsSearchTerm} from '../../../../../store/search/searchSlice'
import {selectSearchTerm} from '../../../../Common/MappingHelperConst'
import {StyledDiv, StyledBackButton, StyledBackdrop} from './AddToSavedProspectsStyles'
import {setAddToSavedProspects} from '../../../../../store/prospectSegment/addToSavedProspects/addToSavedProspectsSlice'
import AlertErrorComponent from '../../../../Common/Error/Alert/AlertComponent'
import PropTypes from 'prop-types'
import {
  setChatbotData,
  setInterestTagId,
  setMatchedProspectId,
  setMatchedProspectList,
  setMessage
} from '../../../../../store/askGivePrism/chatbot/chatbotStreamSlice'
import {
  setButtonViewName,
  setCurrentSelectedFilter,
  setFilters,
  setSwitchFilters
} from '../../../../../store/askGivePrism/askGivePrismSlice'

export const Title = ({title}) => {
  return <Typography sx={{marginBottom: '16px', marginTop: '11px'}}>{title}</Typography>
}

const AddToSavedProspects = () => {
  const dispatch = useDispatch()
  const showCheckboxes = prospectsActions.addToSavedList.checkBoxRequired
  const showAddColumnHeader = prospectsActions.addToSavedList.addColumnRequired
  const hasActions = prospectsActions.addToSavedList.hasActions
  const hasAccordian = prospectsActions.addToSavedList.hasAccordian
  const savedProspectsListName = useSelector((state) => state.addToSavedProspect.savedProspectsList)
  const constituentsList = useSelector((state) => state.saveProspectList.value)
  const searchTermSelector = selectSearchTerm.find((item) => item.contentKey === 'savedProspects')
  const searchString = useSelector((state) => state.search[searchTermSelector.selectorContent])
  const {currentTerm, previousTerm} = searchString
  const searchAllProspectTerm = useSelector((state) => state.search.allProspectsSearch)
  const savedProspects = useSelector((state) => state.getAllProspectsData.getSavedList)
  const selectedItemCurrentPageNumber = useSelector((state) => state.currentPageNumber.savedProspectsValue)
  const [
    addToSavedProspect,
    {data: addToSavedProspectListData, loading: loadingAddToSavedProspectList, error: errorAddToSavedProspectList}
  ] = useAddToSavedProspectList()
  const askGivePrismFilters = useSelector((state) => state.askGivePrism.filters)
  const azureRole = useSelector((state) => state.superUserTenantSlice.azureRole)

  const handleBack = () => {
    dispatch(setButtonViewName('Switch to manual view'))
    dispatch(setSwitchFilters(false))
    dispatch(setCampaignView('defaultView'))
    dispatch(selectedTab(`${SegmentProspects.segments.allProspects.key}`))
    dispatch(constituentIdList([]))
    dispatch(setAddToSavedProspects([]))
    if (previousTerm !== currentTerm || selectedItemCurrentPageNumber !== 1) {
      dispatch(getAllSavedProspectsData([]))
      dispatch(getSavedProspectsPageNumber(1))
      dispatch(updatedSavedProspectsSearchTerm({currentTerm: '', previousTerm: ''}))
    }
    if (searchAllProspectTerm.previousTerm !== searchAllProspectTerm.currentTerm) {
      dispatch(getAllProspectsData([]))
      dispatch(getProspectsPageNumber(1))
      dispatch(updatedAllProspectsSearchTerm({currentTerm: '', previousTerm: ''}))
    }
    if (Object.keys(askGivePrismFilters).length > 0) {
      dispatch(setFilters({}))
      dispatch(getAllProspectsData([]))
      dispatch(getProspectsPageNumber(1))
      dispatch(setCurrentSelectedFilter({}))
    }
    dispatch(setChatbotData([]))
    dispatch(setMessage(''))
    dispatch(setMatchedProspectId([]))
    dispatch(setInterestTagId([]))
    dispatch(setMatchedProspectList([]))
  }

  const [open, setOpen] = useState(false)
  const handleClose = () => {
    setOpen(false)
  }
  const handleOpen = () => {
    setOpen(true)
  }

  const handleAddToSavedList = () => {
    handleOpen()
    setOpenAlert(false)
    addToSavedProspect({
      variables: {
        constituentId: constituentsList,
        listName: savedProspectsListName,
        ...(azureRole ? {azureRole} : {})
      }
    })
  }

  useEffect(() => {
    if (loadingAddToSavedProspectList) {
      setOpenAlert(false)
    }
  }, [loadingAddToSavedProspectList])

  useEffect(() => {
    if (addToSavedProspectListData?.addToList && !loadingAddToSavedProspectList && !errorAddToSavedProspectList) {
      handleClose()
      dispatch(setCampaignView('defaultView'))
      dispatch(selectedTab(`${SegmentProspects.segments.savedProspects.key}`))
      dispatch(constituentIdList([]))
      dispatch(getAllSavedProspectsData([]))
      dispatch(getSavedProspectsPageNumber(1))
      dispatch(updatedSavedProspectsSearchTerm({currentTerm: '', previousTerm: ''}))
      if (Object.keys(askGivePrismFilters).length > 0) {
        dispatch(setChatbotData([]))
        dispatch(setMessage(''))
        dispatch(setMatchedProspectId([]))
        dispatch(setInterestTagId([]))
        dispatch(setMatchedProspectList([]))
        dispatch(setCurrentSelectedFilter({}))
        dispatch(setFilters({}))
        dispatch(getAllProspectsData([]))
        dispatch(getProspectsPageNumber(1))
      }
    }
  })

  const [searchTerm, setSearchTerm] = useState('')
  const handleSearchTerm = (searchTerm) => {
    setSearchTerm(searchTerm)
    dispatch(updatedSavedProspectsSearchTerm({currentTerm: searchTerm, previousTerm: currentTerm}))
  }

  const [openDialog, setOpenDialog] = useState(false)
  const [isSavingSuccess, setIsSavingSuccess] = useState(false)

  const handleOpenDialog = () => {
    setOpenAlert(false)
    setOpenDialog(true)
  }

  useEffect(() => {
    if (isSavingSuccess) {
      setOpenDialog(false)
      dispatch(setCampaignView('defaultView'))
      dispatch(selectedTab(`${SegmentProspects.segments.savedProspects.key}`))
      setIsSavingSuccess(false)
      dispatch(constituentIdList([]))
      dispatch(getAllSavedProspectsData([]))
      dispatch(getSavedProspectsPageNumber(1))
      dispatch(updatedAllProspectsSearchTerm({currentTerm: '', previousTerm: ''}))
    }
  }, [dispatch, isSavingSuccess])

  const [openAlert, setOpenAlert] = useState(false)

  const handleAlertClose = () => {
    setOpenAlert(false)
  }

  useEffect(() => {
    if (!addToSavedProspectListData && !loadingAddToSavedProspectList && errorAddToSavedProspectList) {
      setOpen(false)
      setOpenAlert(true)
    }
  }, [addToSavedProspectListData, loadingAddToSavedProspectList, errorAddToSavedProspectList])

  return (
    <StyledDiv>
      <StyledBackdrop open={open}>
        <CircularProgress color="inherit" />
      </StyledBackdrop>
      <StyledBackButton onClick={handleBack}>{'<< Back to Prospects List'}</StyledBackButton>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          <Title title={'Select from below list to save prospect or create a new list'} />
        </Grid>
        {openAlert && (
          <Grid item sx={{marginLeft: 'auto'}}>
            <AlertErrorComponent
              handleAlertClose={handleAlertClose}
              title={'Error occurred while saving prospect to list.'}
              searchTerm={searchTerm}
            />
          </Grid>
        )}
      </Grid>
      <StyledBox>
        <SearchPanel
          width="35%"
          aria-label="search-for-a-user"
          data-testid="search-panel"
          placeholder="Search for a name"
          setSearchTerm={handleSearchTerm}
        />
        <StyledSaveAndGenerateButton
          onClick={handleOpenDialog}
          disabled={
            (savedProspectsListName.length > 0 || savedProspects?.savedLists?.length === 0) &&
            savedProspects?.savedLists?.length !== 0
          }
        >
          Create new list
        </StyledSaveAndGenerateButton>
        <StyledSaveAndGenerateButton
          sx={{marginRight: 0}}
          onClick={handleAddToSavedList}
          disabled={!savedProspectsListName.length > 0}
        >
          Save to list
        </StyledSaveAndGenerateButton>
      </StyledBox>

      <SavedProspects
        searchPanelRequired={false}
        showAddColumnHeader={showAddColumnHeader}
        showCheckboxes={showCheckboxes}
        hasActions={hasActions}
        hasAccordian={hasAccordian}
      />

      {openDialog && (
        <SaveList
          open={openDialog}
          setOpenDialog={setOpenDialog}
          setIsSavingSuccess={setIsSavingSuccess}
          refreshProspectList={true}
        />
      )}
    </StyledDiv>
  )
}

Title.propTypes = {
  title: PropTypes.string
}

export default AddToSavedProspects
